import { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { FoundationBuildBlock as FoundationBuildBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: FoundationBuildBlockValue }>;

export const FoundationBuildBlock = (props: IProps): React.JSX.Element => {
    return (
        <section
            className={concatClassNames([
                styles.foundationBuildBlock,
                "pdp-features",
                getGlobalSpacingClasses(props.value.spacing),
            ])}
        >
            <div className="main-container">
                <h1 className={styles.foundationBuildBlockHeader}>
                    {props.value.header}
                </h1>
                <div
                    className="foundation-build-block__copy"
                    dangerouslySetInnerHTML={{
                        __html: props.value.copy ?? "",
                    }}
                ></div>
                <div
                    className={concatClassNames([
                        styles.foundationBuildBlockSliderCopy,
                        "foundation-build-block__slider-copy",
                    ])}
                    dangerouslySetInnerHTML={{
                        __html: props.value.slider_copy ?? "",
                    }}
                ></div>
            </div>
        </section>
    );
};
